class Transaction {
    number;
    status;
    amount;
    date;
    cardNum;
    description;
    userFullName;

    constructor(number,userFullName, status, amount, date, cardNum, description) {

        this.number = number;
        this.userFullName = userFullName;
        this.status = status;
        this.amount = amount;
        this.date = date;
        this.cardNum = cardNum;
        this.description = description;

    }

    getID() {
        return this.id
    }
}

export {Transaction}